
import { Button, Modal, StatusBlock, TabManager } from '05-ui-kit';
import { computed, nextTick, onUnmounted, ref, shallowRef, watch } from '@vue/composition-api';
import { useContext } from '@nuxtjs/composition-api';
import { declination } from '@artmizu/utils';
import CompareTable from '../CompareTable/CompareTable.vue';
import Unavailable from '../Unavailable/Unavailable.vue';
import type { CompareCategory } from '~/type/Compare';
import CompareHeaderMobile from '~/components/CompareHeaderMobile/CompareHeaderMobile.vue';
import ActionCompare from '~/action/ActionCompare.vue';
import { useUserListStore } from '~/store/userLists';
import { useResizeStore } from '~/store/resize';
import { useUserStore } from '~/store/user';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const context = useContext();
  const isSliderShowButtons = ref<boolean>();
  const currentCategory = ref<CompareCategory>();
  const list = ref<CompareCategory[]>();
  const activeTab = ref<number>();
  const mobileActiveTab = ref<number>();
  const categoriesCount = ref<number[]>();
  const userListStore = useUserListStore();
  const userStore = useUserStore();
  const resizeStore = useResizeStore();
  let getCompareData: () => void;
  let getProductData: () => void;
  const isOverlayTabsShow = ref(true);
  const modal = ref({
    share: false,
    more: false,
    deleteAllProducts: false,
    deleteCategoryProducts: false
  });
  const isShowTabs = computed(() => list.value?.length);
  const getTotalCategoriesCount = computed(() => {
    const total = categoriesCount.value?.reduce((acc, curr) => acc + curr, 0);
    if (total) return `${total} ${declination(total, ['товаров', 'товара', 'товаров'])}`;
    return undefined;
  });
  const hasCompareList = computed(() => {
    return !!list.value?.length;
  });
  const compareIds = computed(() => userListStore.compareIds);
  const compareAmount = computed(() => userListStore.compareAmount);
  const resize = computed(() => resizeStore.resize);
  watch(() => resize.value, val => {
    if (val && val > 800) overlayTabsHandler();
  });
  const userListsListener = userListStore.$onAction(mutation => {
    const isMutationCompare = ['remove', 'add'].includes(mutation.name);
    if (mutation.name === 'remove') {
      const productId = (mutation.args[0] as {
        id: number;
      });
      const activeCategory = list.value?.find(el => el.id === activeTab.value);
      const isActiveCategoryEmpty = activeCategory?.product?.filter(el => el.id !== productId.id).length;
      if (!isActiveCategoryEmpty) activeTab.value = undefined;
    }
    if (isMutationCompare) {
      nextTick(() => {
        getCompareData?.();
      });
    }
  });
  const userStoreListener = userStore.$onAction(mutation => {
    if (mutation.name === 'setData') {
      nextTick(() => {
        getCompareData?.();
      });
    }
  });
  onUnmounted(() => {
    userListsListener();
    userStoreListener();
  });
  const tabs = shallowRef<HTMLDivElement>();
  function overlayTabsHandler() {
    if (tabs.value) {
      if (tabs.value.scrollLeft >= tabs.value.scrollWidth - tabs.value.clientWidth - 10) return isOverlayTabsShow.value = false;
      return isOverlayTabsShow.value = true;
    }
  }
  function getRequest(id?: number) {
    return hasProduct(id) ? () => Promise.resolve({
      result: currentCategory.value
    }) : context.$api.compare.getProduct;
  }
  function hasProduct(id?: number) {
    return list.value?.find(el => el.id === id)?.product?.length;
  }
  function onSuccessProduct({
    response,
    get
  }: {
    response: Awaited<ReturnType<typeof context.$api.compare.getProduct>>;
    get: () => typeof context.$api.compare.getProduct;
  }) {
    const index = list.value?.findIndex(el => el.id === activeTab.value);
    if (index !== undefined && list.value?.[index]) {
      list.value[index].product = response?.result.product;
      list.value[index].property = response?.result.property;
      list.value[index].blockID = response?.result.blockID;
    }
    getProductData = get;
  }
  function onSuccess({
    response,
    get
  }: {
    response: Awaited<ReturnType<typeof context.$api.compare.getSection>>;
    get: () => typeof context.$api.compare.getSection;
  }) {
    list.value = response?.result || [];
    if (list.value?.length) {
      activeTab.value = activeTab.value || list.value[0].id;
      currentCategory.value = currentCategory.value || list.value[0] || {};
      categoriesCount.value = list.value.map(i => i.quantity);
    }
    if (compareAmount.value) getCompareData = get;
  }
  function onShareClick() {
    modal.value.more = false;
    modal.value.share = true;
  }
  function backToList() {
    mobileActiveTab.value = undefined;
  }
  function reload() {
    location.reload();
  }
  function onChangeTab({
    category,
    index
  }: {
    category: CompareCategory;
    index: number;
  }) {
    currentCategory.value = category;
    currentCategory.value.index = index;
    activeTab.value = mobileActiveTab.value = category.id;
  }
  function handleChangeTab({
    categoryIndex,
    isSliderShowButtonsParametr
  }: {
    categoryIndex?: number;
    isSliderShowButtonsParametr?: boolean;
  }) {
    isSliderShowButtons.value = isSliderShowButtonsParametr;
    if (categoryIndex && categoryIndex >= 0) {
      // Если категория пустая после удаления переключиться на другую
      list.value?.splice(categoryIndex, 1);
      categoriesCount.value?.splice(categoryIndex, 1);
      if (list.value?.length) {
        backToList();
        activeTab.value = list.value[0].id;
        currentCategory.value = list.value[0];
        currentCategory.value.index = 0;
        nextTick(() => {
          getProductData?.();
        });
      } else {
        list.value = undefined;
      }
    }
  }
  function handleChangeTabCount({
    categoryIndex,
    count
  }: {
    categoryIndex: number;
    count: number;
  }) {
    if (categoriesCount.value?.length) categoriesCount.value[categoryIndex] = count;
  }
  function deleteCategoryProducts(callback: ({
    sectionID,
    blockID,
    ids
  }: {
    sectionID?: number;
    blockID?: number;
    ids?: number[];
  }) => Promise<void>) {
    const ids = currentCategory.value?.product?.map(el => el.id);
    callback({
      sectionID: currentCategory.value?.id,
      blockID: currentCategory.value?.blockID,
      ids
    });
    modal.value.deleteCategoryProducts = false;
  }
  function onSuccessDeleteCategoryProducts() {
    if (list.value) {
      const categoryIndex = list.value.findIndex(el => el.id === currentCategory.value?.id);
      handleChangeTab({
        categoryIndex
      });
    }
  }
  return {
    nextTick,
    isSliderShowButtons,
    currentCategory,
    list,
    activeTab,
    mobileActiveTab,
    categoriesCount,
    isOverlayTabsShow,
    modal,
    isShowTabs,
    getTotalCategoriesCount,
    hasCompareList,
    compareIds,
    compareAmount,
    tabs,
    overlayTabsHandler,
    getRequest,
    onSuccessProduct,
    onSuccess,
    onShareClick,
    backToList,
    reload,
    onChangeTab,
    handleChangeTab,
    handleChangeTabCount,
    deleteCategoryProducts,
    onSuccessDeleteCategoryProducts
  };
};
__sfc_main.components = Object.assign({
  StatusBlock,
  Button,
  CompareHeaderMobile,
  CompareTable,
  TabManager,
  Modal,
  ActionCompare,
  Unavailable
}, __sfc_main.components);
export default __sfc_main;
